<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(savePromotion)">
        <b-row>

          <b-col md="12">
            <input-form
              v-model="info.name"
              placeholder="Monthly Discount"
              :validate="'required|max:50'"
              name="Offer Name"
              :label="'Offer Name'"
              :limit="50"
            />
          </b-col>
          <b-col md="12">
            <b-form-group class="custom-radio-inline" label="Promotion Type" v-slot="{ ariaDescribedby }">
              <b-form-radio :disabled="typeOfModal != 'add'" v-for="(i, index) in allPromotionTypes" :key="index" class="custom-radio-color-checked" v-model="info.type" :aria-describedby="ariaDescribedby" name="allPromotionTypes" :value="i.value">
                {{ i.text }}
              </b-form-radio>
            </b-form-group>
          </b-col>

          <template v-if="info.type === 'discount'">
            <b-col md="4">
              <b-form-group
                :label="`Discount Percentage`"
                :label-for="`discount_ratio`"
                class="position-relative"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="`discount_ratio`"
                  :rules="'required|numeric'"
                  class="flex-grow-1"
                >
                  <b-input-group append="%">
                    <b-form-input
                        :disabled="typeOfModal != 'add'"
                      id="mm"
                      v-model="discount.discount_ratio"
                      :class="[{ 'is-invalid': errors.length > 0 }]"
                      :placeholder="'Enter Number'"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="8">
              <b-form-group class="custom-radio-inline" label="Promotion Type" v-slot="{ ariaDescribedby }">
                <b-form-radio class="custom-radio-color-checked" :disabled="typeOfModal != 'add'"  v-model="discount.discount_for" :aria-describedby="ariaDescribedby" name="discount_for" :value="'tickets'">All Tickets</b-form-radio>
                <b-form-radio class="custom-radio-color-checked" :disabled="typeOfModal != 'add'" v-model="discount.discount_for" :aria-describedby="ariaDescribedby" name="discount_for" :value="'promotions'">All Promotions</b-form-radio>
                <b-form-radio class="custom-radio-color-checked" :disabled="typeOfModal != 'add'" v-model="discount.discount_for" :aria-describedby="ariaDescribedby" name="discount_for" :value="'purchases'">All Purchases</b-form-radio>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Start date" label-for="Start date" >
                <flatPickr
                    :disabled="typeOfModal != 'add'"
                  :config="{ minDate: 'today' }"
                  :class="['form-control bg-white']"
                  v-model="info.start_date"
                  placeholder="Start date"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="End date" label-for="End date" >
                <flatPickr
                  :config="{ minDate: info ? info.start_date : ''}"
                  :class="['form-control bg-white']"
                  v-model="info.end_date"
                  placeholder="End date"
                />
              </b-form-group>
            </b-col>

          </template>

          <template v-if="info.type !== 'discount'">

            <b-col md="12">
              <div class="w-100 d-flex justify-content-between align-items-center mb-2" style="gap: 8px" v-for="(ticket, key) in tickets" :key="key">
                <div style="flex:1">
                  <div class="d-flex align-items-center" style="gap:8px">
                    <div class="quantity" >
                      <span class="btns" :class="{ 'is-dimmed': ticket.unlimited == 1 || typeOfModal != 'add' }">
                        <button  @click.prevent="decreaseCount(ticket)" :disabled="ticket.count == 1 || ticket.unlimited == 1 || typeOfModal != 'add'">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.33333 8H12.6667" stroke="#181836" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                        <span>{{ ticket.count }}</span>
                        <button @click.prevent="increaseCount(ticket)" :disabled="ticket.unlimited == 1 || typeOfModal != 'add'">
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 3.3335V12.6668" stroke="#181836" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M3.33333 8H12.6667" stroke="#181836" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                      </span>
                    </div>
                    <input-switch
                        :disabled="typeOfModal != 'add'"
                      :id="`status-${key}`"
                      :name="`status-${key}`"
                      label="Unlimited"
                      v-model="ticket.unlimited"
                      :true-value="1"
                      :false-value="0"/>
                  <main-select
                    style="flex:1; margin:0 "
                    :disabled="typeOfModal != 'add'"
                    @input="selectData"
                    v-model="ticket.ticket_id"
                    :options="getAvailableTickets(key)"
                    :reduce="(data) => data.id"
                    placeholder="--Select Ticket--"
                  >
                    <template #data="{data}">
                      <span class="d-flex gap-2 m-0 p-0 justify-content-between">
                        <span>{{ data.name }}</span>
                        <span class="d-flex gap-1">
                          <span v-if="data.discount_price">({{  data.discount_price }}{{ data.currency }})</span>
                          <span :class="`${data.discount_price ? 'text-decoration-line-through' : ''}`">({{  data.price }}{{ data.currency }})</span>
                        </span>
                      </span>
                    </template>
                    <template #selected-option="{data}">
                      <span>
                        {{ data.name }} - <span v-if="data.discount_price">({{  data.discount_price }}{{ data.currency }})  </span>
                        <span :class="`${data.discount_price ? 'text-decoration-line-through' : ''}`">({{  data.price }}{{ data.currency }})</span>
                      </span>
                    </template>
                  </main-select>
                  </div>
                </div>
                <div style="cursor: pointer" @click="typeOfModal == 'add' ? removeTicket(key) : null" v-if="key !== 0">
                  <span>
                    <i class="las la-trash-alt font-size-22 text-danger"></i>
                  </span>
                </div>
              </div>
              <div class="d-flex justify-content-end" v-if="typeOfModal == 'add'">
               <span @click="addAnotherTicket" class="text-warning cursor-pointer"> + Add Another Ticket </span>
              </div>
            </b-col>
            <b-col md="12">
              <b-row class="d-flex align-item-center">
                <b-col md="6">
                  <validation-provider
                    #default="{ errors }"
                    :name="`price`"
                    :rules="{ required: true, regex: /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/ }"
                    class="flex-grow-1"
                  >
                    <b-form-group :label="'Price'">
                      <b-input-group>
                        <b-form-input
                          :disabled="typeOfModal != 'add'"
                          v-model="prices.price"
                          placeholder="Placeholder"
                          :class="[{ 'is-invalid': errors.length > 0 }]"
                        />
                        <b-input-group-append>
                          <b-form-select :disabled="typeOfModal != 'add'"
                            class="h-100"
                            v-model="prices.currency"
                            :options="[{ value: 'EGP', text: 'EGP' }, { value: '$', text: '$' }, { value: 'EUR', text: 'EUR' }]"
                          />
                        </b-input-group-append>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </b-form-group>
                  </validation-provider>
                </b-col>
                <b-col md="2" class="d-flex align-items-center">
                  <input-switch id="has_discount"
                                name="has_discount"
                                label="Discount"
                                v-model="prices.has_discount"
                                :true-value="1"
                                :false-value="0"
                  />
                </b-col>
                <b-col md="4" >
                  <input-form
                    class="w-100"
                    v-model="prices.discount_price"
                    placeholder="placeholder"
                    :validate="{ regex: /^\d{1,10}(\.\d{1,10})?$/, required: prices.has_discount ? true : false }"
                    name="discount_price"
                    :label="'Discount Price'"
                  />
                </b-col>
              </b-row>
            </b-col>

            <b-col md="3">
              <b-form-group label="Start date" label-for="Start date" >
                <flatPickr
                  :disabled="typeOfModal != 'add'"
                  :config="{ minDate: 'today' }"
                  :class="['form-control bg-white']"
                  v-model="info.start_date"
                  :placeholder="info.start_date ? info.start_date : 'Start date'"
                />
              </b-form-group>
            </b-col>

            <b-col md="3">
              <b-form-group label="End date" label-for="End date" >
                <flatPickr
                  :config="{ minDate: info ? info.start_date : ''}"
                  :class="['form-control bg-white']"
                  v-model="info.end_date"
                  placeholder="End date"
                />
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Description" label-for="Description" >
                <ValidationProvider name="Description" ref="Description" rules="required" v-slot="{ errors }">
                  <b-form-textarea
                    placeholder="Description..."
                    rows="1"
                    v-model="info.description"
                    :class="(errors.length > 0 ? ' is-invalid' : '')"
                  ></b-form-textarea>
                  <div class="d-flex justify-content-between">
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small :class="[{ 'text-danger': info.description.length > 200 }]">{{ (200 > info.description.length) ? 200 - info.description.length : 0 }} characters</small>
                  </div>
                </ValidationProvider>
              </b-form-group>
            </b-col>

            <b-col md="12" v-if="info.type == 'buy_get'">
              <b-form-group class="custom-radio-inline" label="Get" v-slot="{ ariaDescribedby }">
                <b-form-radio class="custom-radio-color-checked" :disabled="typeOfModal != 'add'" v-model="buyGet.buy_get_type" :aria-describedby="ariaDescribedby" name="buy_get_type" :value="'gift'">Gift</b-form-radio>
                <b-form-radio class="custom-radio-color-checked" :disabled="typeOfModal != 'add'" v-model="buyGet.buy_get_type" :aria-describedby="ariaDescribedby" name="buy_get_type" :value="'ticket'">Ticket</b-form-radio>
                <b-form-radio class="custom-radio-color-checked" :disabled="typeOfModal != 'add'" v-model="buyGet.buy_get_type" :aria-describedby="ariaDescribedby" name="buy_get_type" :value="'coupon'">Coupon</b-form-radio>
              </b-form-group>

              <input-form
                v-if="buyGet.buy_get_type == 'gift'"
                v-model="buyGet.gift"
                placeholder="ex: gift"
                :validate="'required|max:50'"
                name="Gift Name"
                :label="'Gift Name'"
                :limit="50"
              />

              <div v-if="buyGet.buy_get_type == 'ticket' && allTickets.length > 0">

                <div
                    class="w-100 d-flex justify-content-between align-items-center mb-2"
                    style="gap: 8px"
                    v-for="(ticket, key) in buyGet.get_tickets"
                    :key="key"
                >
                  <div style="flex:1">
                    <div class="d-flex align-items-center" style="gap:8px">

                      <!-- COUNT -->
                      <div class="quantity">
          <span class="btns" :class="{ 'is-dimmed': ticket.unlimited == 1 }">
            <button
                @click.prevent="decreaseBuyGetCount(ticket)"
                :disabled="ticket.count == 1 || ticket.unlimited == 1 || typeOfModal != 'add'"
            >-</button>

            <span>{{ ticket.count }}</span>

            <button
                @click.prevent="increaseBuyGetCount(ticket)"
                :disabled="ticket.unlimited == 1 || typeOfModal != 'add'"
            >+</button>
          </span>
                      </div>

                      <!-- UNLIMITED -->
                      <input-switch
                          :id="`buyget-status-${key}`"
                          label="Unlimited"
                          v-model="ticket.unlimited"
                          :true-value="1"
                          :false-value="0"
                          :disabled="typeOfModal != 'add'"
                      />

                      <!-- SELECT -->
                      <main-select
                          :disabled="typeOfModal != 'add'"
                          style="flex:1"
                          v-model="ticket.ticket_id"
                          :options="getAvailableBuyGetTickets(key)"
                          :reduce="(data) => data.id"
                          placeholder="--Select Ticket--"
                      >
                        <template #data="{data}">
                          <span class="d-flex gap-2 m-0 p-0 justify-content-between">
                            <span>{{ data.name }}</span>
                            <span class="d-flex gap-1">
                              <span v-if="data.discount_price">({{ data.discount_price }}{{ data.currency }})</span>
                              <span :class="`${data.discount_price ? 'text-decoration-line-through' : ''}`">
                                ({{ data.price }}{{ data.currency }})
                              </span>
                            </span>
                          </span>
                        </template>
                        <template #selected-option="{data}">
                          <span>
                            {{ data.name }} - <span v-if="data.discount_price">({{ data.discount_price }}{{ data.currency }}) </span>
                            <span :class="`${data.discount_price ? 'text-decoration-line-through' : ''}`">
                              ({{ data.price }}{{ data.currency }})
                            </span>
                          </span>
                        </template>
                      </main-select>
                    </div>
                  </div>

                  <!-- REMOVE -->
                  <div
                      v-if="key !== 0"
                      style="cursor: pointer"
                      @click="removeBuyGetTicket(key)"
                  >
                    <span>
                    <i class="las la-trash-alt font-size-22 text-danger"></i>
                  </span>
                  </div>
                </div>

                <!-- ADD -->
                <div class="d-flex justify-content-end" v-if="typeOfModal == 'add'">
                  <span @click="addBuyGetTicket" class="text-warning cursor-pointer">
                    + Add Another Ticket
                  </span>
                </div>
              </div>
             <main-select
              v-if="buyGet.buy_get_type == 'coupon' && allCoupons.length > 0"
                labelTitle='Coupon'
                :validate="'required'"
                :name="`coupon`"
                placeholder="Pick coupon"
                :options="allCoupons"
                label="discount_ratio"
                :reduce="data => data.id"
                v-model="buyGet.get_coupons"
                :multiple="true"
              >
               <template #data="{data}">
                 <div class="d-flex gap-1">
                   <span class="font-weight-bold">{{ data.discount_ratio }}%</span>
                   <span v-if="data.applies_on">All {{ data.applies_on }}</span>
                   <span v-else style="max-width: 100%;display: flex;flex-wrap: wrap; gap:2px">
                    <span v-for="(data, key) in getAppliedOnData(data)" :key="key">
                      <span v-if="key !== 0">,</span> {{ data }}
                    </span>
                 </span>
                 </div>
               </template>
               <template #selected-option="{data}">
                 <div class="d-flex gap-1">
                   <span class="font-weight-bold">{{ data.discount_ratio }}%</span>
                   <span v-if="data.applies_on">All {{ data.applies_on }}</span>
                   <span v-else style="max-width: 100%;display: flex;flex-wrap: wrap; gap:2px">
                    <span v-for="(data, key) in getAppliedOnData(data)" :key="key">
                      <span v-if="key !== 0">,</span> {{ data }}
                    </span>
                 </span>
                 </div>
               </template>
             </main-select>
            </b-col>

            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                :name="`Validity`"
                :rules="{ required: info.unlimited == 0 }"
                class="flex-grow-1"
              >
                <b-form-group>
                  <label for="validity_days" class="d-flex justify-content-between">
                    <span>Validity</span>
                    <input-switch
                        :disabled="typeOfModal != 'add'"
                      id="unlimited"
                      name="unlimited"
                      label="Unlimited"
                      v-model="info.unlimited"
                      :true-value="1"
                      :false-value="0"
                      />
                  </label>
                  <b-input-group append="Day(s)">
                    <b-form-input
                      id="validity_days"
                      :disabled="info.unlimited == 1 || typeOfModal != 'add'"
                      v-model="info.validity_days"
                      placeholder="Placeholder"
                      :class="[{ 'is-invalid': errors.length > 0}]"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>


            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                :name="`Payment limit`"
                :rules="{ required: info.payment_unlimited == 0 }"
                class="flex-grow-1"
              >
                <b-form-group>
                  <label for="payment_limit" class="d-flex justify-content-between">
                    <span>Payment limit</span>
                    <input-switch id="payment_unlimited"
                                  name="payment_unlimited"
                                  label="Payment Unlimited"
                                  v-model="info.payment_unlimited"
                                  :true-value="1"
                                  :false-value="0"
                    />
                  </label>
                  <b-form-input
                    id="payment_limit"
                    :disabled="info.payment_unlimited == 1"
                    v-model="info.payment_limit"
                    placeholder="Placeholder"
                    :class="[{ 'is-invalid': errors.length > 0}]"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <b-form-group label="Conditions" label-for="Conditions" >
                <ValidationProvider name="Conditions" ref="Conditions" v-slot="{ errors }">
                  <b-form-textarea
                    :disabled="typeOfModal != 'add'"
                    placeholder="Conditions..."
                    rows="2"
                    v-model="info.conditions"
                    :class="(errors.length > 0 ? ' is-invalid' : '')"
                  ></b-form-textarea>
                  <div class="d-flex justify-content-between">
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small :class="[{ 'text-danger': info.conditions.length > 200 }]">{{ (200 > info.conditions.length) ? 200 - info.conditions.length : 0 }} characters</small>
                  </div>
                </ValidationProvider>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Requirements" label-for="Requirements" >
                <ValidationProvider name="Requirements" ref="Requirements" v-slot="{ errors }">
                  <b-form-textarea
                    :disabled="typeOfModal != 'add'"
                    placeholder="Requirements..."
                    rows="2"
                    v-model="info.requirements"
                    :class="(errors.length > 0 ? ' is-invalid' : '')"
                  ></b-form-textarea>
                  <div class="d-flex justify-content-between">
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small :class="[{ 'text-danger': info.requirements.length > 200 }]">{{ (200 > info.requirements.length) ? 200 - info.requirements.length : 0 }} characters</small>
                  </div>
                </ValidationProvider>
              </b-form-group>
            </b-col>

          </template>
        </b-row>

        <b-row>
          <b-col md="12" class="mt-4">
            <div class="d-flex justify-content-center">
              <b-button :class="`button-${typeOfModal == 'add' ? 'orange' : 'blue'}-modal`" type="submit">
                <i v-if="!requestLoading" :class="`las la-${typeOfModal == 'add' ? 'plus' : 'pen'}`"></i>
                <spinner-loading v-else></spinner-loading>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </ValidationObserver>
  </div>
</template>
<script>
import flatPickr from 'vue-flatpickr-component'

export default {
  props: {
    requestLoading: { type: Boolean, default: false },
    typeOfModal: { type: String, default: 'add' },
    promotionDetails: { type: Object, default: () => ({}) },
    allCoupons: { type: Array, default: () => [] },
    allTickets: { type: Array, default: () => [] }
  },

  components: { flatPickr },

  data () {
    return {
      tickets: [
        {
          ticket_id: '',
          unlimited: 0,
          count: 1
        }
      ],

      allPromotionTypes: [
        { text: 'Discount', value: 'discount' },
        { text: 'Package', value: 'package' },
        { text: 'Buy & Get', value: 'buy_get' }
      ],

      info: {
        name: '',
        id: null,
        type: 'discount',
        start_date: '',
        end_date: '',
        description: '',
        conditions: '',
        requirements: '',
        unlimited: 0,
        payment_unlimited: 0,
        validity_days: '',
        payment_limit: ''
      },

      discount: {
        discount_ratio: '',
        discount_for: ''
      },

      prices: {
        price: '',
        has_discount: 0,
        discount_price: '',
        currency: 'EGP'
      },

      buyGet: {
        buy_get_type: '',
        gift: '',
        get_tickets: [
          {
            ticket_id: '',
            unlimited: 0,
            count: 1
          }
        ],
        get_coupons: []
      }
    }
  },

  methods: {
    getAppliedOnData (data)  {
      return [...data.tickets.map(ticket => ticket.name),...data.promotions.map(promotion => promotion.name)]
    },
    addBuyGetTicket () {
      this.buyGet.get_tickets.push({
        ticket_id: '',
        unlimited: 0,
        count: 1
      })
    },

    removeBuyGetTicket (index) {
      this.buyGet.get_tickets.splice(index, 1)
    },

    increaseBuyGetCount (ticket) {
      ticket.count++
    },

    decreaseBuyGetCount (ticket) {
      ticket.count = Math.max(1, ticket.count - 1)
    },

    getAvailableBuyGetTickets (index) {
      const selected = new Set(
          this.buyGet.get_tickets.map(t => t.ticket_id).filter(Boolean)
      )

      return this.allTickets.filter(ticket => {
        if (ticket.id === this.buyGet.get_tickets[index].ticket_id) return true
        return !selected.has(ticket.id)
      })
    },

    // ===============================
    // Tickets
    // ===============================

    addAnotherTicket () {
      this.tickets.push({
        ticket_id: '',
        unlimited: 0,
        count: 1
      })
    },

    removeTicket (index) {
      this.tickets.splice(index, 1)
    },

    decreaseCount (ticket) {
      ticket.count = Math.max(1, ticket.count - 1)
    },

    increaseCount (ticket) {
      ticket.count++
    },

    getAvailableTickets (index) {
      const selected = new Set(
          this.tickets.map(t => t.ticket_id).filter(Boolean)
      )

      return this.allTickets.filter(ticket => {
        if (ticket.id === this.tickets[index].ticket_id) return true
        return !selected.has(ticket.id)
      })
    },

    // ===============================
    // Reset Logic
    // ===============================

    resetDiscount () {
      this.discount = {
        discount_ratio: '',
        discount_for: ''
      }
    },

    resetBuyGet () {
      this.buyGet = {
        buy_get_type: '',
        gift: '',
        get_tickets: [
          { ticket_id: '', unlimited: 0, count: 1 }
        ],
        get_coupons: []
      }
    },

    // ===============================
    // Save
    // ===============================

    buildBasePayload () {
      const base = {
        name: this.info.name,
        type: this.info.type,
        start_date: this.info.start_date,
        end_date: this.info.end_date,
        description: this.info.description,
        conditions: this.info.conditions,
        requirements: this.info.requirements,
        unlimited: +this.info.unlimited,
        payment_unlimited: +this.info.payment_unlimited
      }

      if (this.info.unlimited == 0) {
        base.validity_days = this.info.validity_days
      } else {
        base.validity_days = ''
      }

      if (this.info.payment_unlimited == 0) {
        base.payment_limit = this.info.payment_limit
      } else {
        base.payment_limit = ''
      }

      return base
    },

    savePromotion () {
      let payload = this.buildBasePayload()

      console.log('payload -> ', payload)

      // ===== Discount
      if (this.info.type === 'discount') {
        payload = {
          ...payload,
          ...this.discount
        }
        delete payload.payment_limit
        delete payload.payment_unlimited
        delete payload.conditions
        delete payload.description
        delete payload.validity_days
        delete payload.unlimited
      }

      // ===== Package / BuyGet
      if (this.info.type !== 'discount') {
        payload = {
          ...payload,
          tickets: this.tickets.map(ticket => {
            const base = {
              ticket_id: ticket.ticket_id,
              unlimited: +ticket.unlimited
            }

            if (!ticket.unlimited) {
              base.count = ticket.count
            }

            return base
          }),
          ...this.prices
        }

        if (this.prices.has_discount == false) {
          delete payload.discount_price
        }

        if (this.info.type === 'buy_get') {
          payload.buy_get_type = this.buyGet.buy_get_type

          if (this.buyGet.buy_get_type === 'gift') {
            payload.gift = this.buyGet.gift
          }

          if (this.buyGet.buy_get_type === 'ticket') {
            payload.get_tickets = this.buyGet.get_tickets.map(ticket => {
              const base = {
                ticket_id: ticket.ticket_id,
                unlimited: +ticket.unlimited
              }

              if (!ticket.unlimited) {
                base.count = ticket.count
              }

              return base
            })
          }

          if (this.buyGet.buy_get_type === 'coupon') {
            payload.get_coupons = this.buyGet.get_coupons
          }
        }
      }

      if (this.typeOfModal === 'add') {
        this.$emit('addPromotion', payload)
      } else {

        this.$emit('editPromotion', {
          ...payload,
          _method: 'patch',
          id: this.info.id
        })
      }
    },

    // ===============================
    // Fill Data
    // ===============================

    fillData () {
      if (!this.promotionDetails || !Object.keys(this.promotionDetails).length) return

      this.info = {
        name: this.promotionDetails.name || '',
        id: this.promotionDetails.id || null,
        type: this.promotionDetails.type || 'discount',
        start_date: this.promotionDetails.start_date || '',
        end_date: this.promotionDetails.end_date || '',
        description: this.promotionDetails.description || '',
        conditions: this.promotionDetails.conditions || '',
        requirements: this.promotionDetails.requirements || '',
        unlimited: Number(this.promotionDetails.unlimited),
        payment_unlimited: Number(this.promotionDetails.payment_unlimited),
        validity_days: this.promotionDetails.validity_days || '',
        payment_limit: this.promotionDetails.payment_limit || ''
      }

      this.tickets = (this.promotionDetails.tickets || []).map(ticket => ({
        ticket_id: ticket.ticket_id,
        unlimited: ticket.unlimited ? 1 : 0,
        count: ticket.count || 1
      }))

      console.log('this.promotionDetails.discount_for -> ', this.promotionDetails.discount_ratio)
      this.discount = {
        discount_ratio: this.promotionDetails.discount_ratio || '',
        discount_for: this.promotionDetails.discount_for || ''
      }

      this.prices = {
        price: this.promotionDetails.price || '',
        has_discount: Number(this.promotionDetails.has_discount),
        discount_price: this.promotionDetails.discount_price || '',
        currency: this.promotionDetails.currency || 'EGP'
      }

      this.buyGet = {
        buy_get_type: this.promotionDetails.buy_get_type || '',
        gift: this.promotionDetails.gift || '',
        get_tickets: (this.promotionDetails.get_tickets || []).map(t => ({
        ticket_id: t.ticket_id,
        unlimited: t.unlimited ? 1 : 0,
        count: t.count || 1
        })),
        get_coupons: this.promotionDetails.get_coupons || []
      }
    }
  },

  watch: {
    promotionDetails: {
      handler () {
        this.fillData()
      },
      immediate: true
    },

    'info.type' (newVal) {
      if (newVal !== 'discount') {
        this.resetDiscount()
      }

      if (newVal !== 'buy_get') {
        this.resetBuyGet()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.input-group .input-group-text {
  background: transparent !important;
  border: 1px solid #d7dbda !important;
}

.btns.is-dimmed {
  opacity: 0.4;
  pointer-events: none;
}
</style>
